/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordInvoiceFieldComponent } from '../../admin/form/form-record/fields/invoice/form-record-invoice-field.component';
/* eslint-enable */

export class FormRecordInvoiceFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordInvoiceFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
